import { Pipe, PipeTransform } from '@angular/core';
import { VariablePerformerEntity } from '../../entities/variable-performer.entity';

@Pipe({ name: 'variableName' })
export class VariableNamePipe implements PipeTransform {
    constructor() { }
    transform(users: VariablePerformerEntity[], defaultVal = ''): string {
        let r = '';
        users.forEach(u => {
            r += u.name + '，';
        });
        if (r) {
            r = r.substring(0, r.length - 1);
        }
        return r ? r : defaultVal;
    }
}
